<template>
    <div class="pageroot">
        <div style="display: flex; flex-direction: column; gap: 12px;">

            <div class="search-block">
                <div class="search-item">
                    <div class="caption">利用日</div>
                    <DatePicker v-model="Param.bookingDateFrom" />～
                    <DatePicker v-model="Param.bookingDateTo" position="top: 28px; right: 0;" />
                </div>

                <div class="search-item">
                    <div class="caption">予約</div>
                    <select v-model="Param.bookingState">
                        <option :value="0"></option>
                        <option :value="1">仮予約</option>
                        <option :value="2">本予約</option>
                        <option :value="4">無効予約</option>
                    </select>
                </div>

                <div class="search-item">
                    <div class="caption">予約番号</div>
                    <input v-model="Param.bookingCode" style="width: 110px;" maxlength="10" />
                </div>

                <div class="search-item">
                    <div class="caption">葬祭業者</div>
                    <select v-model="Param.companyId" style="width: 150px">
                        <option :value="0"></option>
                        <option v-for="x in Companys" :value="x.companyId" :key="x.compnayId">
                            {{ x.companyName }}
                        </option>
                    </select>
                </div>

                <div class="search-item">
                    <div class="caption">利用区分</div>
                    <select v-model="Param.infoType">
                        <option :value="0"></option>
                        <option v-for="x in Selections.infoType()" :value="x[0]" :key="x[0]">{{x[1]}}</option>
                    </select>
                </div>

                <div class="search-item">
                    <div class="caption">お別れ室</div>
                    <select v-model="Param.useFacility1">
                        <option :value="0"></option>
                        <option :value="2">利用する</option>
                    </select>
                </div>

                <div class="search-item">
                    <div class="caption">霊安室</div>
                    <select v-model="Param.useFacility2">
                        <option :value="0"></option>
                        <option :value="2">利用する</option>
                    </select>
                </div>

                <div class="search-item">
                    <div class="caption">待合室</div>
                    <select v-model="Param.useWaitingRoom">
                        <option :value="0"></option>
                        <option :value="2">利用する</option>
                    </select>
                </div>
            </div>

            <div style="border-top: 1px dashed lightgray;"></div>

            <div class="search-block">
                <div class="search-item">
                    <div class="caption">利用者名(カナ)</div>
                    <input v-model="Param.infoKana1" style="width: 80px;" placeholder="セイ" />
                    <input v-model="Param.infoKana2" style="width: 80px; margin: 0 0 0 2px" placeholder="メイ" />
                </div>
                
                <div class="search-item">
                    <div class="caption">年齢</div>
                    <select v-model="Param.infoAgeFrom">
                        <option :value="''"></option>
                        <option v-for="x in Selections.infoAge().filter(x=>x[1]!='不詳')" :value="x[0]" :key="x[0]">{{x[1]}}</option>
                    </select>～
                    <select v-model="Param.infoAgeTo">
                        <option :value="''"></option>
                        <option v-for="x in Selections.infoAge().filter(x=>x[1]!='不詳')" :value="x[0]" :key="x[0]">{{x[1]}}</option>
                    </select>
                </div>

                <div class="search-item">
                    <div class="caption">性別</div>
                    <select v-model="Param.infoSex">
                        <option :value="0"></option>
                        <option v-for="x in Selections.infoSex()" :value="x[0]" :key="x[0]">{{x[1]}}</option>
                    </select>
                </div>

                <div class="search-item">
                    <div class="caption">住所</div>
                    <select v-model="Param.infoAreaId" style="width: 100px">
                        <option :value="0"></option>
                        <option :value="-1">区域内</option>
                        <option v-for="x in Areas" :value="x.areaId" :key="x.areaId">
                            {{ x.areaName }}
                        </option>
                    </select>
                    <input v-model="Param.infoAddress" style="width: 200px; margin-left: 5px;" placeholder="部分一致" />
                </div>

                <div class="search-item">
                    <div class="caption">死亡日</div>
                    <CheckButton v-model="Param.infoDeathDate" style="margin-right: 6px">指定する</CheckButton>
                    <DatePicker v-model="Param.infoDeathDateFrom" :disabled="!Param.infoDeathDate" />～
                    <DatePicker v-model="Param.infoDeathDateTo" :disabled="!Param.infoDeathDate" position="top: 28px; right: 0;" />
                </div>

                <div class="search-item">
                    <div class="caption">申請者名(カナ)</div>
                    <input v-model="Param.ownerKana1" style="width: 80px;" placeholder="セイ" />
                    <input v-model="Param.ownerKana2" style="width: 80px; margin: 0 0 0 2px" placeholder="メイ" />
                </div>
            </div>

            <div style="border-top: 1px dashed lightgray;"></div>

            <div class="search-block">
                <div class="search-item">
                    <div class="caption">死亡届の届出先</div>
                    <select v-model="Param.infoReportAreaId" style="width: 100px" :disabled="IsVisitor && VisitorAreaId > 0">
                        <option :value="0"></option>
                        <option v-for="x in Areas" :value="x.areaId" :key="x.areaId">
                            {{ x.areaName }}
                        </option>
                    </select>
                </div>
                
                <div class="search-item">
                    <div class="caption">火葬済証明書の発行数</div>
                    <select v-model="Param.certificates1">
                        <option :value="-1"></option>
                        <option v-for="i of 10" :value="i-1" :key="i">{{i-1}}</option>
                    </select>
                </div>

                <div class="search-item">
                    <div class="caption">分骨証明書の発行数</div>
                    <select v-model="Param.certificates2">
                        <option :value="-1"></option>
                        <option v-for="i of 10" :value="i-1" :key="i">{{i-1}}</option>
                    </select>
                </div>

                <button style="display:flex; align-items: center; gap: 10px; padding: 0 15px 0 5px; margin-left:auto;"
                        :disabled="Loading" @click="search">
                    <svg yu-icon="search" size="20" style="color: gray"></svg>検索</button>
                    
                <button style="display:flex; align-items: center; gap: 10px; padding: 0 15px 0 5px;"
                        v-if="!IsVisitor" :disabled="Loading" @click="download">
                    <svg yu-icon="download" size="20" style="color: gray"></svg>CSV出力</button>
            </div>
        </div>

        <div style="border-bottom: 1px solid lightgray; margin: 14px 0 32px 0;"></div>

        <table style="margin-top: 0.5rem;">
            <thead>
                <tr>
                    <th style="padding: 0"></th>
                    <th>利用日時</th>
                    <th>利用者名</th>
                    <th>死亡日</th>
                    <th>葬祭業者</th>
                    <th>連絡先</th>
                    <th style="width: 150px">更新日時</th>
                    <th style="width: 40px"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="rec in SearchData" :key="rec.bookingId">
                    <td style="padding: 0;">{{rec.bookingState==4 ? "無効" : ""}} </td>
                    <td>{{ getBookingDateTime(rec) }}</td>
                    <td class="j-mincho">{{ rec.infoName1 }} {{ rec.infoName2 }}</td>
                    <td>{{ rec.infoDeathDateFlag==1 ? "不詳" : formatDate(rec.infoDeathDate, "yyyy年M月d日") }}</td>
                    <td>{{ rec.companyNameShort }}</td>
                    <td>{{ rec.telNumber }}</td>
                    <td>{{ formatDate(rec.updateOn, "yyyy/M/d HH:mm") }}</td>
                    <td>
                        <button v-if="!IsVisitor" class="cell-button" @click="openBookMenu(rec)" :disabled="Loading">
                            <svg yu-icon="pen" width="20" style="color: gray"></svg>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        
        <div style="display: none">
            <DashboardPagePopup  ref="booking-edit-dialog" class="dialog" :TargetBooking="TargetBooking" @reload="reload" />
        </div>
    </div>
</template>

<script>
import { Dialog } from '../../assets/dialog.js'
import { Auth } from '../../assets/auth.js'
import { BookingController } from "../../assets/api/bookingController"
import { MasterController } from "../../assets/api/masterController.js"
import { CompanyController } from "../../assets/api/companyController.js"
import { BookingInfoSelections } from "../../assets/bookingInfoOptions.js"
import Util from "../../assets/utility.js"
import DatePicker from "../../components/DatePicker.vue"
import CheckButton from "../../components/CheckButton.vue"
import DashboardPagePopup from "./DashboardPagePopup.vue"

export default {
    components: {
        DatePicker,
        CheckButton,
        DashboardPagePopup,
    },
    data() {
        return {
            Loading : false,
            IsVisitor : Auth.getAuthState().role==2,
            VisitorAreaId: Auth.getAuthState().companyId,
            Api: {
                booking: new BookingController(),
                company: new CompanyController(),
                master: new MasterController(),
            },

            /** @type {CompanyNameListData[]} */
            Companys:[],
            /** @type {MsArea[]} */
            Areas:[],
            Selections: BookingInfoSelections(),

            /**
             * 検索結果データ
             * @type {BookingSearchData[]} */
            SearchData: [],

            /**
             * 選択中予約 （予約選択時） 
             * @type {BookingOutline} */
            TargetBooking: {},

            /**
             * 検索条件
             */
            Param: {
                bookingCode: "",
                bookingDateFrom: Util.getToday(),
                bookingDateTo: Util.getToday(),
                bookingState: 2,
                companyId: 0,
                infoType: 0,
                infoKana1: "",
                infoKana2: "",
                infoSex: 0,
                infoAgeFrom: "",
                infoAgeTo: "",
                infoAreaId: 0,
                infoAddress: "",
                infoDeathDate: false,
                infoDeathDateFrom: Util.getToday(),
                infoDeathDateTo: Util.getToday(),
                infoReportAreaId: 0,
                ownerKana1: "",
                ownerKana2: "",
                useFacility1: 0,
                useFacility2: 0,
                useWaitingRoom: 0,
                certificates1: -1,
                certificates2: -1,
            },
        }
    },
    mounted() {
        Util.animate(".pageroot", ":scope>div, table, h2")
        this.reloadMaster()

        if(location.hash.length > 1){
            try{ //保存された検索条件
                var p = JSON.parse(decodeURI(location.hash.substring(1)))
                Object.keys(this.Param).forEach(k=>{
                    if(!(k in p)) return
                    if(this.Param[k] instanceof Date) this.Param[k] = new Date(p[k])
                    else this.Param[k] = p[k]
                })
                this.search()
            } catch(e){ /* */ }
        }
    },
    methods: {
        async reloadMaster(){
            this.Loading = true

            let res = await Promise.all([
                this.Api.company.getNameList(),
                this.Api.master.getAreaList(),
            ])
            if(res.some(x=>!x.ok)) return
            this.Loading = false

            this.Companys = res[0].data
            this.Areas = res[1].data
        },
        async reload(){
            return this.search()
        },
        /** 検索実行 */
        async search(){
            location.hash = encodeURI(JSON.stringify(this.Param))

            Dialog.spinAsync()
            let res = await this.Api.booking.search(this.Param)

            if(!res.ok){
                if(res.status == 400) {
                    this.warning(res.body)
                }
                return
            }
            Dialog.close()
            this.SearchData = res.data
        },

        /** 予約選択 */
        async openBookMenu(booking){
            this.TargetBooking = booking
            let dlg = this.$refs["booking-edit-dialog"].$el
            Dialog.showElementAsync(dlg)
        },

        /** CSV出力 */
        async download(){
            Dialog.spinAsync()
            let res = await this.Api.booking.searchCsv(this.Param)
            Dialog.close()
            
            if(!res.ok){
                this.error("データを作成できませんでした。"
                    + (res.status==400 ? `\n${res.body}` : ""))
                return
            }

            let a = document.createElement("a")
            a.download = "予約検索.csv"
            a.href = URL.createObjectURL(res.body)
            a.click()
            URL.revokeObjectURL(a.href)
        },

        async ask(msg){
            return await Dialog.messageboxAsync(msg,
                Dialog.Messagebox_Buttons_OkCancel,
                Dialog.Messagebox_Icon_Info)
        },
        async error(msg){
            await Dialog.messageboxAsync(msg,
                Dialog.Messagebox_Buttons_Ok,
                Dialog.Messagebox_Icon_Error)
        },
        async warning(msg){
            await Dialog.messageboxAsync(msg,
                Dialog.Messagebox_Buttons_Ok,
                Dialog.Messagebox_Icon_Warn)
        },
        getBookingDateTime(rec){
            if(!rec || !("bookingDate" in rec)) return ""
            return Util.formatDate(rec.bookingDate, "yyyy年M月d日")
                + " " + Util.formatTime(rec.bookingTime)
        },
        formatDate(d, fromat){
            if(!d) return ""
            return Util.formatDate(d, fromat)
        }
    },
}
</script>

<style scoped>
.search-item{
    display: flex;
    align-items: center;
}
.search-block{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px 14px;
}
.caption{
    white-space: nowrap;
    font-size: 0.9rem;
    font-weight: bold;
    margin-right: 4px;
}
.caption::before{
    content: "| ";
    color: gray;
}
table{
    width: 100%;
    max-width: 1200px;
    border-collapse: separate;
    border-spacing: 0;
}
th{
    text-align: left;
    font-weight: normal;
    border-bottom: 2px solid #9f98bb;
    padding: 0 5px;
}
td{
    border-bottom: 1px solid lightgray;
    padding: 5px;
}
.cell-button{
    display: flex;
    align-items: center;
    padding: 3px;
    color:gray
}
</style>